// removed by extract-text-webpack-plugin
module.exports = {"recipeCustomisationBox":"G9f6d05"};